var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreener(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.75H7.25V7C7.25 7.414 7.586 7.75 8 7.75C8.414 7.75 8.75 7.414 8.75 7V3C8.75 2.586 8.414 2.25 8 2.25C7.586 2.25 7.25 2.586 7.25 3V4.25H3C2.586 4.25 2.25 4.586 2.25 5C2.25 5.414 2.586 5.75 3 5.75ZM12 5.75H21C21.414 5.75 21.75 5.414 21.75 5C21.75 4.586 21.414 4.25 21 4.25H12C11.586 4.25 11.25 4.586 11.25 5C11.25 5.414 11.586 5.75 12 5.75ZM3 12.75H12C12.414 12.75 12.75 12.414 12.75 12C12.75 11.586 12.414 11.25 12 11.25H3C2.586 11.25 2.25 11.586 2.25 12C2.25 12.414 2.586 12.75 3 12.75ZM21 11.25H16.75V10C16.75 9.586 16.414 9.25 16 9.25C15.586 9.25 15.25 9.586 15.25 10V14C15.25 14.414 15.586 14.75 16 14.75C16.414 14.75 16.75 14.414 16.75 14V12.75H21C21.414 12.75 21.75 12.414 21.75 12C21.75 11.586 21.414 11.25 21 11.25ZM8 16.25C7.586 16.25 7.25 16.586 7.25 17V18.25H3C2.586 18.25 2.25 18.586 2.25 19C2.25 19.414 2.586 19.75 3 19.75H7.25V21C7.25 21.414 7.586 21.75 8 21.75C8.414 21.75 8.75 21.414 8.75 21V17C8.75 16.586 8.414 16.25 8 16.25ZM21 18.25H12C11.586 18.25 11.25 18.586 11.25 19C11.25 19.414 11.586 19.75 12 19.75H21C21.414 19.75 21.75 19.414 21.75 19C21.75 18.586 21.414 18.25 21 18.25Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreener);
export default __webpack_public_path__ + "static/media/screener.088e3027e7f2b8ceb024a0a81c8287da.svg";
export { ForwardRef as ReactComponent };